export const queryKeys = {
  PERMISSIONS: "permissions",
  ROLE_DEFINITION_DETAILS: "roleDefinitionDetails",
  ROLE_DEFINITIONS: "roleDefinitions",
  SELF: "selfQuery",
  TEAMS: "teams",
  USER_DETAILS: "userDetails",
  USER_LIST: "userList",
  USER_PRODUCTS: "userProducts"
};
